import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import RightBackgroundImage from "../../Images/backgroundImage.jpg";
import {
  getOwner,
  createNewNftContract,
  mintNFT,
  metalordNFTsDetail,
  allMetalordNFTContractsDeployed,
} from "./contractData";
import ConnectWalletPopup from "../../Components/ConfirmPopup";
import Loading from "../../Components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import { userInfoContext } from "../../Context/userInfoContext";
import { userProviderContext } from "../../Context/userProviderContext";
const Root = styled.div`
  background-image: url(${RightBackgroundImage});
  background-size: cover;
  background-position: center;
  height: 100vh;
`;
const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 1rem 8rem;
`;
const TextContractContainer = styled.div`
  margin: 3rem 0;
`;
const TextWrapper = styled.div`
  width: 80%;
`;
const ContractTextWrapper = styled.div`
  margin: 10px 0;
`;
const ContractText = styled.text`
  font-size: 28px;
  font-family: sans-serif;
  font-weight: 500;
  /* margin: 0 20px; */
`;
const Text = styled.input`
  width: 40%;
  font-size: 16px;
  padding: 15px 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 8px;
  border: none;
  /* margin-left: 20px; */
  outline: none;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 5rem 0;
  width: 80%;
`;
const Button = styled.button`
  padding: 10px 8rem;
  font-size: 20px;
  border-radius: 25px;
  outline: none;
  border: none;
  font-weight: 500;
  cursor: pointer;
  margin: 0 10px;
`;

const Button2 = styled.button`
  font-size: 16px;
  padding: 15px 20px;
  /* margin-right:10px; */
  border-radius: 11px;
  border: none;
  outline: none;
  cursor: pointer;
`;

const Table = styled.table`
  /* overflow: scroll; */
  width: 100%;
  /* width: 1900px; */
  margin: 30px 0;
  min-width: 600px;
  border-collapse: collapse;
  /* margin-left:20px; */
`;

const TableRow = styled.div`
  margin-top: 50px;
  display: grid;
  grid-template-columns: 37% 7% 7% 7% 7% 7% 7% 7% 7% 7%;
`;

const TableHead = styled.th`
  color: white;
  font-size: 20px;
  text-transform: capitalize;
  font-weight: 600;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const TableCell = styled.td`
  font-size: 20px;
  margin: 15px 0;
  font-weight: 500;
`;

const TableRowCellWrapper = styled.div`
  display: grid;
  grid-template-columns: 37% 7% 7% 7% 7% 7% 7% 7% 7% 7%;
  justify-content: center;
  align-items: center;
`;
const SelectBox = styled.select`
  width: 40%;
  font-size: 16px;
  padding: 15px 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 8px;
  border: none;
  outline: none;
`;

const SelectOptions = styled.option`
  background-color: #fff;
  color: #000;
`;
const CreateNfts = ({ allContractDetails }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [symbol, setSymbol] = useState("");
  const [address, setAddress] = useState("");
  const [perform, setPerform] = useState("");
  const [mintAddress, setMintAddress] = useState("");
  const [recipientAddress, setRecipientAddress] = useState("");
  const [numberOfTokens, setNumberOfTokens] = useState(0);
  const [allNftList, setAllNftList] = useState([]);
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [showCreatedPopup2, setShowCreatedPopup2] = useState(false);
  const [subCategory, setSubCategory] = useState();
  const [nftName, setNftName] = useState();
  const [assetType, setAssetType] = useState();
  const [assetSubType, setAssetSubType] = useState();
  const [rare, setRare] = useState();
  const [description, setDescription] = useState();
  const [image, setImage] = useState();
  const {userToken}=useContext(userInfoContext)
  const {userProvider}=useContext(userProviderContext);

  useEffect(() => {
    if (allContractDetails?.address) {
      getAllNftMarketplaceList();
    }
  }, []);

  useEffect(() => {
    if (allContractDetails?.address) {
      setAddress(allContractDetails.address);
      getAllNftMarketplaceList();
    }
  }, [allContractDetails]);

  const clearData = () => {
    setName("");
    setSymbol("");
    setRecipientAddress("");
    setNumberOfTokens(0);
  };
  const makeApiRequest = async (data, address) => {
    try {
      const response = await axios.post(
        `${baseUrl}/nftmarketplace/api/v1/save_token_details/${address}`,
        data,
        {
          headers:{
            Authorization:`Bearer ${userToken}`,
            loginType:userProvider
          }
        }
      );
      if(response?.data?.success==true){
        setLoading(false)
        setPerform('Minted NFTs')
        setShowCreatedPopup(true);
      }
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon:"error",
        title:"OOPS...",
        text:err?.response?.data?.message||err?.message||"something went wrong"
      })
      setLoading(false);
    }
  };
  const callMint = async (nftContractAddress, index) => {
    console.log(
      allNftList[index]?.address,
      allNftList[index]?.name,
      subCategory,
      rare,
      description,
      image,
      symbol,
      parseInt(allNftList[index]?.totalSupply)
    );
    let data = new FormData();
    data.append("contractName", allNftList[index]?.name);
    data.append("symbol", allNftList[index]?.symbol);
    // data.append("supply", parseInt(allNftList[index]?.totalSupply));
    data.append("supply", 100);
    data.append("name", nftName);
    data.append("assetType", assetType);
    data.append("assetSubType", assetSubType);
    data.append("category", rare);
    data.append("description", description);
    data.append("nft", image);
    data.append("dailyReward", "0");
    data.append("xp", "0");
    data.append("hash", "0");
    data.append("owner", recipientAddress);
    data.append("count", numberOfTokens);
    // data.append("loginType",userProvider);
    setLoading(true);

    await mintNFT(
      allContractDetails.metalordNFTManagerContract,
      nftContractAddress,
      recipientAddress,
      numberOfTokens
    )
      .then(async (res) => {
        if (res !== null) {
          // clearData();

          await makeApiRequest(data, allNftList[index]?.address.toLowerCase());
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          icon:"error",
          title:"OOPS...",
          text:err?.response?.data?.message||err?.message||"something went wrong"
        })
        console.log(err);
      });
  };

  const createNftMarket = async () => {
    setLoading(true);
    const ownerAddress = await getOwner(
      allContractDetails.metalordNFTManagerContract
    );

    if (address === ownerAddress) {
      await createNewNftContract(
        allContractDetails.metalordNFTManagerContract,
        name,
        symbol
      )
        .then((res) => {
          if (res !== null) {
            // clearData();
            setLoading(false);
            setPerform("created");
            setShowCreatedPopup(true);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      // alert(" you are not a owner user");
      Swal.fire({
        icon: "error",
        title: "OOPS...",
        text: " you are not a owner user.",
      });
      setLoading(false);
    }
  };

  const getAllNftMarketplaceList = async () => {
    setLoading(true);
    setShowCreatedPopup(false);
    setAllNftList([]);
    let i = 0;
    let arr = [];
    while (i !== null) {
      await allMetalordNFTContractsDeployed(
        allContractDetails.metalordNFTManagerContract,
        i
      )
        .then(async (res) => {
          if (res !== null) {
            await metalordNFTsDetail(
              allContractDetails.metalordNFTManagerContract,
              res
            )
              .then(async (allDetailsOfNft) => {
                arr.push({
                  ...allDetailsOfNft,
                  address: res,
                });

                setShowCreatedPopup(false);
                i++;
              })
              .catch((err) => {
                setLoading(false);
                setShowCreatedPopup(false);
                setAllNftList(arr);
                i = null;
              });
          }
        })
        .catch((err) => {
          setLoading(false);
          setShowCreatedPopup(false);
          setAllNftList(arr);
          i = null;
        });
    }
    setLoading(false);
  };

  const updateOneRecordAfterMint = async () => {
    setLoading(true);
    setShowCreatedPopup2(false);

    setTimeout(async () => {
      const updatedDetails = await metalordNFTsDetail(
        allContractDetails.metalordNFTManagerContract,
        mintAddress
      );

      const updatedNftList = await allNftList.map((nftDetail) => {
        if (nftDetail.address === mintAddress) {
          return {
            ...nftDetail,
            ...updatedDetails,
            totalSupply: Number(updatedDetails?.totalSupply),
          };
        } else {
          return nftDetail;
        }
      });

      setAllNftList(updatedNftList);
      setMintAddress("");
      setLoading(false);
    }, 1500);
  };

  return (
    <>
      {loading && <Loading />}
      <Root>
        <Container>
          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Contract Name</ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                value={name}
                placeholder="Types Name"
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </TextWrapper>
          </TextContractContainer>
          {/* <TextContractContainer>
          <ContractTextWrapper>
            <ContractText> Supply </ContractText>
          </ContractTextWrapper>
          <TextWrapper>
            <Text type="text" placeholder="10000" />
          </TextWrapper>
        </TextContractContainer> */}

          <TextContractContainer>
            <ContractTextWrapper>
              <ContractText> Symbol </ContractText>
            </ContractTextWrapper>
            <TextWrapper>
              <Text
                type="text"
                value={symbol}
                placeholder="Types Symbol"
                onChange={(e) => {
                  setSymbol(e.target.value);
                }}
              />
            </TextWrapper>
          </TextContractContainer>

          <ButtonWrapper>
            <Button onClick={createNftMarket}> Create </Button>
            {/* <Button>Mint</Button> */}
          </ButtonWrapper>
          {showCreatedPopup && (
            <ConnectWalletPopup
              showPopup={showCreatedPopup}
              setShowPopup={setShowCreatedPopup}
              onClickFun={getAllNftMarketplaceList}
              text={`Congratulation you ${perform} successfully.`}
            ></ConnectWalletPopup>
          )}
          {showCreatedPopup2 && (
            <ConnectWalletPopup
              showPopup={showCreatedPopup2}
              setShowPopup={setShowCreatedPopup2}
              onClickFun={updateOneRecordAfterMint}
              text={`Congratulation you ${perform} successfully.`}
            ></ConnectWalletPopup>
          )}

          <Table>
            <ContractText> NFT staking Data </ContractText>
            <TableRow>
              <TableHead>Contract Address</TableHead>
              <TableHead>Nft Name</TableHead>
              <TableHead>Symbol</TableHead>
              {/* <TableHead> Name </TableHead>
              <TableHead> Type </TableHead>
              <TableHead> SubCat </TableHead>
              <TableHead> Description </TableHead>
              <TableHead> Image </TableHead>
              <TableHead>Action</TableHead> */}
              <TableHead>Supply</TableHead>
            </TableRow>
            {allNftList?.length > 0 &&
              allNftList.map((nftDetail, index) => {
                return (
                  <>
                    <TableRowCellWrapper>
                      {/* <TableCell>{nftDetail?.address || "-"}</TableCell> */}
                      <TableCell>
                        {/* {nftDetail?.address.slice(0, 5) || "-"}...
                        {nftDetail?.address.slice(
                          address.length - 4,
                          address.length
                        ) || "-"} */}
                        {nftDetail?.address.toLowerCase()}
                      </TableCell>
                      <TableCell>{nftDetail?.name || "-"}</TableCell>
                      <TableCell>{nftDetail?.symbol || "-"}</TableCell>
                      {/* <TableCell> Name </TableCell>
                      <TableCell> Type </TableCell>
                      <TableCell> SubCat </TableCell>
                      <TableCell> Description </TableCell>
                      <TableCell> Image </TableCell>
                      <TableCell>Action</TableCell> */}
                      <TableCell>
                        {Number(nftDetail?.totalSupply) || "-"}
                      </TableCell>
                    </TableRowCellWrapper>

                    {/* <Text
                      type="string"
                      placeholder="Sub Category"
                      onChange={(e) => {
                        setSubCategory(e.target.value);
                      }}
                    /> */}
                    <Text
                      type="string"
                      placeholder="Name"
                      onChange={(e) => {
                        setNftName(e.target.value);
                      }}
                    />
                    <Text
                      type="string"
                      placeholder="Asset Type"
                      onChange={(e) => {
                        setAssetType(e.target.value);
                      }}
                    />
                    <Text
                      type="string"
                      placeholder="Asset Sub Type"
                      onChange={(e) => {
                        setAssetSubType(e.target.value);
                      }}
                    />
                    <SelectBox onChange={(e) => setRare(e.target.value)}>
                      <SelectOptions>Select Category</SelectOptions>
                      <SelectOptions value="common">Common</SelectOptions>
                      <SelectOptions value="uncommon">Uncommon</SelectOptions>
                      <SelectOptions value="rare">Rare</SelectOptions>
                      <SelectOptions value="legendary">Legendary</SelectOptions>
                    </SelectBox>
                    <Text
                      type="string"
                      placeholder="Description"
                      onChange={(e) => {
                        setDescription(e.target.value);
                      }}
                    />
                    <Text
                      type="file"
                      placeholder="Image"
                      onChange={(e) => {
                        setImage(e.target.files[0]);
                      }}
                    />
                    <Text
                      type="string"
                      placeholder="receiver address"
                      onChange={(e) => {
                        setRecipientAddress(e.target.value.toLowerCase());
                      }}
                    />
                    <Text
                      type="number"
                      placeholder="No of Tokens"
                      onChange={(e) => {
                        setNumberOfTokens(e.target.value);
                      }}
                      style={{
                        margin: "0 5px",
                      }}
                    />
                    <Button2
                      onClick={() => {
                        setMintAddress(nftDetail?.address);
                        callMint(nftDetail?.address, index);
                      }}
                    >
                      Mint
                    </Button2>
                  </>
                );
              })}
          </Table>

          {/* <table>
            NFT staking Data
            <tr>
              <th>Contract Address</th>
              <th>Nft Name</th>
              <th>Symbol</th>
              <th>Supply</th>
              <th>Action</th>
            </tr>
            {
              allNftList?.length > 0 && allNftList.map(nftDetail => {
                return (
                  <>
                    <tr>
                      <td>{nftDetail?.address || '-'}</td>
                      <td>{nftDetail?.name || '-'}</td>
                      <td>{nftDetail?.symbol || '-'}</td>
                      <td>{Number(nftDetail?.totalSupply) || '-'}</td>
                      <td>
                        <Text type="string" placeholder="receiver address" onChange={(e) => {
                          setRecipientAddress(e.target.value)
                        }} />
                        <Text type="number" placeholder="0" onChange={(e) => {
                          setNumberOfTokens(e.target.value)
                        }} />
                        <button onClick={() => {
                          setMintAddress(nftDetail?.address)
                          callMint(nftDetail?.address)
                        }}>
                          Mint
                        </button>
                      </td>
                    </tr>
                  </>
                )
              })
            }
          </table> */}
        </Container>
      </Root>
    </>
  );
};

export default CreateNfts;
